export const fixturePlaylistState = {
  otav_connected: true,
  is_playing: true,
  is_paused: false,
  playback_status: 'Playing',
  item_index: 1,
  item_elapsed: 64,
  item_remaining: 26,
  real_clock_start_time: null,
  remote_playlist_id: 'playlist-abc-123',
  items: [
    {
      item_index: 0,
      slug: 'COLD-OPEN',
      name: 'Show open / tease package',
      clip_type: 0,
      type: 'PKG',
      duration: 30,
      reporter: null,
      clock_in_time: '17:00:00',
      playback_status: 'Stopped',
      is_disabled: false,
      is_cued_as_next: false,
      story_id: null
    },
    {
      item_index: 1,
      slug: 'CITY-BUDGET',
      name: 'City Council approves budget plan',
      clip_type: 0,
      type: 'VO/SOT',
      duration: 90,
      reporter: 'D. Robinson',
      clock_in_time: '17:00:30',
      playback_status: 'Playing',
      is_disabled: false,
      is_cued_as_next: false,
      story_id: 1001
    },
    {
      item_index: 2,
      slug: 'WEATHER-TOSS',
      name: 'Evening forecast toss to weather',
      clip_type: 4,
      type: 'LIVE',
      duration: 120,
      reporter: 'S. Frank',
      clock_in_time: '17:02:00',
      playback_status: 'Stopped',
      is_disabled: false,
      is_cued_as_next: true,
      story_id: null
    },
    {
      item_index: 3,
      slug: 'SCHOOL-FUNDING',
      name: 'State School Funding Cuts Announced',
      clip_type: 0,
      type: 'PKG',
      duration: 105,
      reporter: 'M. Chen',
      clock_in_time: '17:04:00',
      playback_status: 'Stopped',
      is_disabled: false,
      is_cued_as_next: false,
      story_id: 1002
    },
    {
      item_index: 4,
      slug: 'CRIME-SUMMIT',
      name: 'Mayor hosts community safety forum',
      clip_type: 3,
      type: 'VO',
      duration: 45,
      reporter: 'R. Patel',
      clock_in_time: '17:04:00',
      playback_status: 'Stopped',
      is_disabled: false,
      is_cued_as_next: false,
      story_id: null
    },
    {
      item_index: 5,
      slug: 'SPORTS-LEAD',
      name: 'Browns training camp opens',
      clip_type: 0,
      type: 'PKG',
      duration: 75,
      reporter: 'S. Williams',
      clock_in_time: '17:04:00',
      playback_status: 'Stopped',
      is_disabled: false,
      is_cued_as_next: false,
      story_id: null
    },
    {
      item_index: 6,
      slug: 'BREAK-1',
      name: 'Commercial Break',
      clip_type: 0,
      type: 'BREAK',
      duration: 120,
      reporter: null,
      clock_in_time: '17:04:00',
      playback_status: 'Stopped',
      is_disabled: false,
      is_cued_as_next: false,
      story_id: null
    }
  ]
}

export const fixtureOttState = {
  status: 'LIVE',
  channel: 'Uplynk + Seymour',
  item_count: 5,
  viewer_count: 1247,
  current_headline: 'WCPO News at 4 - Live Coverage'
}

export const fixtureSocialState = {
  status: 'IDLE',
  provider: 'Social News Desk',
  queued_count: 7,
  next_post_time: '5:15 PM',
  next_platform: 'Twitter',
  next_headline: 'State school funding cuts will affect 47 districts across Ohio...'
}

export const fixtureWebCmsState = {
  status: 'LIVE',
  provider: 'Brightspot',
  queue_status: 'In Queue',
  current_headline: 'City Council approves $4.2B budget plan after marathon Session'
}

export const fixtureTickerState = {
  status: 'LIVE',
  provider: 'Live Ticker',
  active_headlines: 12,
  breaking_count: 2
}

export const fixtureSchedulerState = {
  enabled: true,
  current_playlist_name: 'Morning News 6AM',
  next_playlist_name: 'Midday News 12PM',
  playlists: [
    { playlist_path: '/playlists/morning-6am.mpl', name: 'Morning News 6AM' },
    { playlist_path: '/playlists/midday-12pm.mpl', name: 'Midday News 12PM' },
    { playlist_path: '/playlists/evening-5pm.mpl', name: 'Evening News 5PM' }
  ],
  events: [
    { start_time: '06:00:00', playlist_name: 'Morning News 6AM' },
    { start_time: '12:00:00', playlist_name: 'Midday News 12PM' },
    { start_time: '17:00:00', playlist_name: 'Evening News 5PM' }
  ]
}

export const fixtureRouterState = {
  outputs: [
    { id: 'out-1', name: 'Program', routed_input: 'in-2' },
    { id: 'out-2', name: 'Preview', routed_input: 'in-1' },
    { id: 'out-3', name: 'Record', routed_input: 'in-2' }
  ],
  inputs: [
    { id: 'in-1', name: 'Camera 1' },
    { id: 'in-2', name: 'Camera 2' },
    { id: 'in-3', name: 'Graphics' }
  ]
}

export const fixtureHeartbeat = {
  uptime_secs: 3600,
  agent_version: '1.0.0-fixture',
  otav_connected: true
}

export const fixtureRouterLabels = {
  sources: [
    { index: 1, label: 'CAM 1' },
    { index: 2, label: 'CAM 2' },
    { index: 3, label: 'Graphics' },
    { index: 4, label: 'Remote Feed' }
  ],
  destinations: [
    { index: 1, label: 'Program' },
    { index: 2, label: 'Preview' },
    { index: 3, label: 'Record' }
  ]
}
